import CreateMultiAutocomplete from './CreateMultiAutocomplete';

export default CreateMultiAutocomplete;
